import Loader from "components/loader";
import React, { useEffect } from "react";
import useUserSession from "zustand-store/user";
import { getCurrentUser } from "aws-amplify/auth";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";

const withAuth = (WrappedComponent) => {
  return (props) => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const { isAuthenticated, setIsAuthenticated } = useUserSession();

    const planValue = searchParams.get("plan");

    useEffect(() => {
      const checkIfLoggedIn = async () => {
        try {
          await getCurrentUser();
          setIsAuthenticated(true);
        } catch (error) {
          console.error("Error checking user satus:", error);
          setIsAuthenticated(false);
        }
      };

      checkIfLoggedIn();
    }, [setIsAuthenticated]);

    if (isAuthenticated === null) {
      return <Loader />;
    }

    if (isAuthenticated === false) {
      const isFirstTimeUser =
        planValue && location.pathname.includes("/subscription");

      const loginLink = isFirstTimeUser
        ? `/register?plan=${planValue}`
        : "/login";

      return <Navigate to={loginLink} replace />;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withAuth;
